export const aNamed3 = "a-named3";
